import { render, staticRenderFns } from "./companyUser.vue?vue&type=template&id=19024958&scoped=true&"
import script from "./companyUser.vue?vue&type=script&lang=js&"
export * from "./companyUser.vue?vue&type=script&lang=js&"
import style0 from "./companyUser.vue?vue&type=style&index=0&id=19024958&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19024958",
  null
  
)

export default component.exports